import { render, staticRenderFns } from "./item.vue?vue&type=template&id=55b0cbfa&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"
import style0 from "./item.vue?vue&type=style&index=0&id=55b0cbfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b0cbfa",
  null
  
)

export default component.exports